<template>
    <div>
        <h4 class="col-12" v-if="title">{{ title }}</h4>
        <form-input v-if="type == 'input'" :label="label" @input="setValue" />
        <form-input
            v-if="type == 'number'"
            type="number"
            :label="label"
            @input="setValue"
        />
        <form-radio
            v-if="type == 'radio'"
            :itens="itens"
            :label="label"
            @input="setValue"
        />
        <form-checkbox
            v-if="type == 'checkbox'"
            :label="label"
            @input="setValue"
        />
        <div v-if="type == 'checklist'">
            <h4 class="col-12">{{ label }}</h4>
            <form-checkbox
                v-for="(item, index) in itens"
                :label="item.value"
                @input="setValue"
                :key="index"
            />
        </div>

        <form-select
            v-if="type == 'select'"
            :itens="itens"
            :label="label"
            v-model="value"
            @change="setValue"
        />
        <h4 v-if="type == 'text'" class="col-12">{{ text }}</h4>
        <!-- <form-toggle-group
            v-if="type == 'checkbox'"
            :itens="itens"
            v-model="value"
        /> -->
    </div>
</template>
<script>
export default {
    props: ["type", "itens", "title", "label", "value", "index", "text"],
    data() {
        return {
            item: null,
            money: {
                decimal: ",",
                thousands: "",
                prefix: "",
                suffix: "",
                precision: 0,
                masked: false,
            },
        };
    },
    beforeMount() {
        // if (this.type == "money") {
        //     this.item = this.value + ",00";
        // } else {
        //     this.item = this.value;
        // }
        this.item = this.value;
    },
    watch: {
        value(n, o) {
            this.item = n;
        },
    },
    methods: {
        setValue(item) {
            this.$emit("input", item, this.index);
        },
        toUpper(item) {
            return item.toUpperCase();
        },
    },
};
</script>
<style lang="css">
input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    /* Not removed via appearance */
    margin: 0;

    font: inherit;
    color: currentColor;
    width: 1.15em;
    height: 1.15em;
    border: 0.15em solid currentColor;
    border-radius: 0.15em;
    transform: translateY(-0.075em);

    display: grid;
    place-content: center;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    /* Windows High Contrast Mode */
    background-color: #5895ff;
}
input[type="radio"]::before {
    background-color: #5895ff;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

input[type="checkbox"]:focus {
    outline: max(2px, 0.15em) solid currentColor;
    outline-offset: max(2px, 0.15em);
}

input[type="checkbox"]:disabled {
    cursor: not-allowed;
}
</style>
